/*
=================================================================================
 __      __.__     ___________           .__    ____ ________  ________.________
/  \    /  \__| ___\__    ___/___   ____ |  |__/_   /   __   \/   __   \   ____/
\   \/\/   /  |/    \|    |_/ __ \_/ ___\|  |  \|   \____    /\____    /____  \ 
 \        /|  |   |  \    |\  ___/\  \___|   Y  \   |  /    /    /    //       \
  \__/\  / |__|___|  /____| \___  >\___  >___|  /___| /____/    /____//______  /
       \/          \/           \/     \/     \/                             \/ 
=================================================================================

  All of the routes for the Material Dashboard 2 PRO React are added here,
  You can add a new route, customize the routes and delete the routes here.

  Once you add a new route on this file it will be visible automatically on
  the Sidenav.

  For adding a new route you can follow the existing routes in the routes array.
  1. The `type` key with the `collapse` value is used for a route.
  2. The `type` key with the `title` value is used for a title inside the Sidenav. 
  3. The `type` key with the `divider` value is used for a divider between Sidenav items.
  4. The `name` key is used for the name of the route on the Sidenav.
  5. The `key` key is used for the key of the route (It will help you with the key prop inside a loop).
  6. The `icon` key is used for the icon of the route on the Sidenav, you have to add a node.
  7. The `collapse` key is used for making a collapsible item on the Sidenav that contains other routes
  inside (nested routes), you need to pass the nested routes inside an array as a value for the `collapse` key.
  8. The `route` key is used to store the route location which is used for the react router.
  9. The `href` key is used to store the external links location.
  10. The `title` key is only for the item with the type of `title` and its used for the title text on the Sidenav.
  10. The `component` key is used to store the component of its route.
*/

// Material Dashboard 2 PRO React layouts

// @mui icons
import Icon from '@mui/material/Icon';

// Images
import Logout from 'layouts/authen/Logout';
import User from 'layouts/user/User';
import Role from 'layouts/role/Role';
import Invoice from 'layouts/invoice/Invoice';
// import Menus from "layouts/menu/Menus";
// import MainMenu from "layouts/menu/MainMenu";
import Company from 'layouts/company/Company';
import Customer from 'layouts/customer/Customer';
import Quotation from 'layouts/quotation/Quotation';
import Unit from 'layouts/product/Unit';
import Product from 'layouts/product/Product';
import PurchaseRequest from 'layouts/purchaserequest/PurchaseRequest';
import PurchaseOrder from 'layouts/purchaseorder/PurchaseOrder';
import PointOfSale from 'layouts/pos/PointOfSale';
import Receive from 'layouts/receive/Receive';
import PurchasePay from 'layouts/purchase_pay/PurchasePay';
import ExportStore from 'layouts/export_store/ExportStore';
import ImportStore from 'layouts/import_store/ImportStore';
import RequestRawmat from 'layouts/request_rawmat/RequestRawmat';
import PickupRawmat from 'layouts/pickup_rawmat/PickupRawmat';
// import JobOrder from "layouts/job_order/JobOrder";
import ProductionFinish from 'layouts/production_finish/ProductionFinish';
import SaleOrder from 'layouts/sale_order/SaleOrder';
import Car from 'layouts/car/Car';
// import NotifyGroup from "layouts/notify/NotifyGroup";
// import Notify from "layouts/notify/Notify";
import PermissionType from 'layouts/permission/PermissionType';
import Permission from 'layouts/permission/Permission';
import Bank from 'layouts/bank/Bank';
import Province from 'layouts/setting/Province';
import District from 'layouts/setting/District';
import SubDistrict from 'layouts/setting/SubDistrict';
import Warehouse from 'layouts/setting/Warehouse';
import BankAccount from 'layouts/bank/BankAccount';
import Supplier from 'layouts/supplier/Supplier';
import PurchaseType from 'layouts/purchaseorder/PurchaseType';
import PayoutType from 'layouts/payout/PayoutType';
import Payout from 'layouts/payout/Payout';
import Shipping from 'layouts/shipping/Shipping';
import Log from 'layouts/tool/Log';
import AdjustStock from 'layouts/adjust_stock/AdjustStock';
import DashboardAdmin from 'layouts/dashboard/DashboardAdmin';
import DashboardSale from 'layouts/dashboard/DashboardSale';
import Branch from 'layouts/branch/Branch';
// import Account from "layouts/account/Account";
// import AccountType from "layouts/account/AccountType";
// import Creditor from "layouts/creditor/Creditor";
// import Debtor from "layouts/debtor/Debtor";
import Receipt from 'layouts/receipt/Receipt';
import ReceiveStore from 'layouts/receive_store/ReceiveStore';
import PickupStore from 'layouts/pickup_store/PickupStore';
import ReceiveType from 'layouts/receive_store/ReceiveType';
import PickupType from 'layouts/pickup_store/PickupType';
import Message from 'layouts/profile/Message';
import Saleman from 'layouts/saleman/Saleman';
import Meeting from 'layouts/saleman/Meeting';
import Task from 'layouts/task/Task';
import ProfileEdit from 'layouts/profile/ProfileEdit';
import Prefix from 'layouts/user/Prefix';
import ProfilePassword from 'layouts/profile/ProfilePassword';
import DashboardStock from 'layouts/dashboard/DashboardStock';
import DashboardProduction from 'layouts/dashboard/DashboardProduction';
import DashboardPurchase from 'layouts/dashboard/DashboardPurchase';
import DashboardAccount from 'layouts/dashboard/DashboardAccount';
import ProductionPlan from 'layouts/production_plan/ProductionPlan';
// import AccountRound from "layouts/account/AccountRound";
// import AccountVat from "layouts/account/AccountVat";
// import AccountWithHolding from "layouts/account/AccountWithHolding";
// import AccountNote from "layouts/account/AccountNote";
// import AccountCredit from "layouts/account/AccountCredit";
// import AccountLink from "layouts/account/AccountLink";
// import AccountPlan from "layouts/account_plan/AccountPlan";
import DashboardMenu from 'layouts/dashboard/DashboardMenu';
import PurchaseInvoice from 'layouts/purchase_invoice/PurchaseInvoice';
import Currency from 'layouts/currency/Currency';
import Steppers from 'layouts/stepper/Steppers';
// import Document from "layouts/menu/Document";
import VoucherReceived from 'layouts/voucher_received/VoucherReceived';
import PaymentVoucher from 'layouts/payment_voucher/PaymentVoucher';
import Note from 'layouts/note/Note';
import Target from 'layouts/target/Target';
import Criteria from 'layouts/criteria/Criteria';
import Backup from 'layouts/setting/Backup';
import DeveloperStock from 'layouts/setting/DeveloperStock';
import Ticket from 'layouts/ticket/Ticket';
import TicketType from 'layouts/ticket/TicketType';
import Campaign from 'layouts/campaign/Campaign';
import QrCode from 'layouts/qrcode/QrCode';
import QrCodeGen from 'layouts/qrcode/QrCodeGen';
import Location from 'layouts/warehouse/Location';
import ExportRequest from 'layouts/export_request/ExportRequest';
import ExportSheet from 'layouts/export_sheet/ExportSheet';
import ShippingBranch from 'layouts/shipping_branch/ShippingBranch';
import AdvertiseImage from 'layouts/advertise/AdvertiseImage';
import AdvertiseVDO from 'layouts/advertise/AdvertiseVDO';
import ReportPurchase from 'layouts/report_purchase/ReportPurchase';
import ReportWarehouse from 'layouts/report_stock/ReportWarehouse';
import ReportProduct from 'layouts/report_product/ReportProduct';
import ProductColor from 'layouts/product/ProductColor';
import ProductSize from 'layouts/product/ProductSize';
import ProductSKU from 'layouts/product/ProductSKU';
import ProductRawmat from 'layouts/product/ProductRawmat';
import ProductionReceive from 'layouts/production_receive/ProductionReceive';
import ExportInvite from 'layouts/export_invite/ExportInvite';
import BillOfMaterial from 'layouts/bom/BillOfMaterial';
import Config from 'layouts/setting/Config';
import MasterData from 'layouts/setting/MasterData';
import PosMiniExample from 'layouts/pos/PosMiniExample';
import ExportMove from 'layouts/export_move/ExportMove';
import Cart from 'layouts/cart/Cart';
import SlideShow from 'layouts/slideshow/SlideShow';
import CountingRequest from 'layouts/counting_request/CountingRequest';
import Counting from 'layouts/counting/Counting';
import Counts from 'layouts/counts/Counting';
import CountingSession from 'layouts/counts/CountingSession';
import Department from 'layouts/user/Department';
import Position from 'layouts/user/Position';
import Manual from 'layouts/user/Manual';
import Cashier from 'layouts/cashier/Cashier';
import Tag from 'layouts/tag/Tag';
import DashboardPos from 'layouts/dashboard_pos/DashboardPos';
import ReportAccount from 'layouts/report_account/ReportAccount';
import ReportPowerBi from 'layouts/report_power_bi/ReportPowerBi';
import ReportManageBranch from 'layouts/report_manage_branch/ReportManageBranch';
import Brand from 'layouts/product/Brand';
import BringForward from 'layouts/bring_forward/BringForward';
import ReportSale from 'layouts/report_sale/ReportSale';
import ImportSale from 'layouts/import_sale/ImportSale';
import BestSeller from 'layouts/product/BestSeller';
import ReturnStore from 'layouts/return_store/ReturnStore';
import ReturnSupplier from 'layouts/return_supplier/ReturnSupplier';
import ReportInventory from 'layouts/report_inventory/ReportInventory';
import ReturnStoreType from 'layouts/return_store/ReturnStoreType';
import ImportStock from 'layouts/import_stock/ImportStock';
import Ecommerce from 'layouts/product/Ecommerce';
import Promotion from 'layouts/promotion/Promotion';
import Cash from 'layouts/cash/Cash';
import DropMoney from 'layouts/drop_money/DropMoney';
import CloseShift from 'layouts/close_shift/CloseShift';
import ReturnProduct from 'layouts/return_product/ReturnProduct';
import ReportPOS from 'layouts/report_pos/ReportPOS';
import ReportProduction from 'layouts/report_production/ReportProduction';
import ConfigStore from 'layouts/setting/ConfigStore';
import PosQrCode from 'layouts/qrcode/PosQrCode';
import ExportRequestTag from 'layouts/qrcode/ExportRequestTag';
import Coupon from 'layouts/coupon/Coupon';
import CouponDetail from 'layouts/coupon/CouponDetail';
import Country from 'layouts/setting/Country';
import Production from 'layouts/production/Production';
import RoleUser from 'layouts/role/RoleUser';
import PosCustomerScreen from 'layouts/branch/PosCustomerScreen';
import CreditCard from 'layouts/setting/CreditCard';
import CreditCardFee from 'layouts/setting/CreditCardFee';
import CashierShift from 'layouts/cashier_shift/CashierShift';
import Picture from 'layouts/picture/Picture';
import QR from 'layouts/qr/QR';
import CancelBill from 'layouts/cancel_bill/CancelBill';
import ProductDepartment from 'layouts/product/Department';
import ProductCategory from 'layouts/product/Category';
import ProductGroup from 'layouts/product/Group';
import ProductSubGroup from 'layouts/product/SubGroup';
import ProductLine from 'layouts/product/Line';
import ProductItem from 'layouts/product/Item';
import Price from 'layouts/price_tag/Price';
import SupplierType from 'layouts/supplier/SupplierType';
import AnnouncementSetting from 'layouts/announcement/AnnouncementSetting';
import QrBottomBill from 'layouts/qr_bottom_bill/QrBottomBill';
import DashboardSaleProfit from 'layouts/dashboard/DashboardSaleProfit';
import CreditSale from 'layouts/credit_sale/CreditSale';
import QuotationBranch from 'layouts/quotation_branch/QuotationBranch';
import DashboardGP from 'layouts/dashboard/DashboardGP';
import SendChange from 'layouts/send_change/SendChange';
import DashboardPosV2 from 'layouts/dashboard_pos/DashboardPosV2';

const routes = [
  {
    type: 'collapse',
    name: '',
    key: 'avatar',
    icon: null,
    collapse: [
      {
        name: 'menu.profile',
        key: 'profile',
        route: '/profile',
        component: <ProfileEdit />,
      },
      {
        name: 'menu.changepassword',
        key: 'changepassword',
        route: '/changepassword',
        component: <ProfilePassword />,
      },
      {
        name: 'menu.message',
        key: 'message',
        route: '/message',
        component: <Message />,
      },
      {
        name: 'menu.ticket',
        key: 'ticket',
        route: '/ticket',
        component: <Ticket />,
      },
      {
        name: 'menu.manual',
        key: 'manual',
        route: '/manual',
        component: <Manual />,
      },
      {
        name: 'menu.logout',
        key: 'logout',
        route: '/logout',
        component: <Logout />,
      },
    ],
  },
  { type: 'divider', key: 'divider-0' },
  {
    type: 'collapse',
    name: 'menu.dashboard',
    key: 'dashboard_menu',
    icon: <Icon fontSize='medium'>dashboard</Icon>,
    collapse: [
      {
        name: 'menu.dashboard_menu',
        key: 'dashboard',
        route: '/dashboard',
        component: <DashboardMenu />,
      },
      {
        name: 'menu.dashboard_admin',
        key: 'dashboard_admin',
        route: '/dashboard_admin',
        component: <DashboardAdmin />,
      },
      {
        name: 'menu.dashboard_pos_v2',
        key: 'dashboard_pos_v2',
        route: '/dashboard_pos_v2',
        component: <DashboardPosV2 />,
      },
      {
        name: 'menu.dashboard_pos',
        key: 'dashboard_pos',
        route: '/dashboard_pos',
        component: <DashboardPos />,
      },
      {
        name: 'menu.dashboard_sale',
        key: 'dashboard_sale',
        route: '/dashboard_sale',
        component: <DashboardSale />,
      },
      {
        name: 'menu.dashboard_purchase',
        key: 'dashboard_purchase',
        route: '/dashboard_purchase',
        component: <DashboardPurchase />,
      },
      {
        name: 'menu.dashboard_stock',
        key: 'dashboard_stock',
        route: '/dashboard_stock',
        component: <DashboardStock />,
      },
      {
        name: 'menu.dashboard_production',
        key: 'dashboard_production',
        route: '/dashboard_production',
        component: <DashboardProduction />,
      },
      {
        name: 'menu.dashboard_account',
        key: 'dashboard_account',
        route: '/dashboard_account',
        component: <DashboardAccount />,
      },
      {
        name: 'menu.target',
        key: 'target',
        route: '/target',
        component: <Target />,
      },
      {
        name: 'menu.dashboard_sale_profit',
        key: 'dashboard_sale_profit',
        route: '/dashboard_sale_profit',
        component: <DashboardSaleProfit />,
      },
      {
        name: 'menu.dashboard_gp',
        key: 'dashboard_gp',
        route: '/dashboard_gp',
        component: <DashboardGP />,
      },
    ],
  },
  {
    type: 'collapse',
    name: 'menu.product',
    key: 'product_menu',
    icon: <Icon fontSize='medium'>settings_input_composite</Icon>,
    collapse: [
      {
        name: 'menu.product',
        key: 'product',
        route: '/product',
        component: <Product />,
      },
      {
        name: 'menu.rawmaterial',
        key: 'product_rawmat',
        route: '/product_rawmat',
        component: <ProductRawmat />,
      },
      {
        name: 'menu.campaign',
        key: 'campaign',
        route: '/campaign',
        component: <Campaign />,
      },
      {
        name: 'menu.tag',
        key: 'tag',
        route: '/tag',
        component: <Tag />,
      },
      {
        name: 'menu.brand',
        key: 'brand',
        route: '/brand',
        component: <Brand />,
      },
      {
        name: 'menu.products_level_department',
        key: 'products_level_department',
        route: '/products_level_department',
        component: <ProductDepartment />,
      },
      {
        name: 'menu.products_level_category',
        key: 'products_level_category',
        route: '/products_level_category',
        component: <ProductCategory />,
      },
      {
        name: 'menu.products_level_group',
        key: 'products_level_group',
        route: '/products_level_group',
        component: <ProductGroup />,
      },
      {
        name: 'menu.products_level_sub_group',
        key: 'products_level_sub_group',
        route: '/products_level_sub_group',
        component: <ProductSubGroup />,
      },
      {
        name: 'menu.products_level_line',
        key: 'products_level_line',
        route: '/products_level_line',
        component: <ProductLine />,
      },
      {
        name: 'menu.products_level_item',
        key: 'products_level_item',
        route: '/products_level_item',
        component: <ProductItem />,
      },
      {
        name: 'menu.size',
        key: 'size',
        route: '/size',
        component: <ProductSize />,
      },
      {
        name: 'menu.color',
        key: 'color',
        route: '/color',
        component: <ProductColor />,
      },
      {
        name: 'menu.unit',
        key: 'unit',
        route: '/unit',
        component: <Unit />,
      },
      {
        name: 'menu.best_seller',
        key: 'best_seller',
        route: '/best_seller',
        component: <BestSeller />,
      },
      {
        name: 'menu.price_tag',
        key: 'price_tag',
        route: '/price_tag',
        component: <Price />,
      },
    ],
  },
  {
    type: 'collapse',
    name: 'menu.sale',
    key: 'sale_menu',
    icon: <Icon fontSize='medium'>monetization_on</Icon>,
    collapse: [
      {
        name: 'menu.customer',
        key: 'customer',
        route: '/customer',
        component: <Customer />,
      },
      {
        name: 'menu.ecommerce',
        key: 'ecommerce',
        route: '/ecommerce',
        component: <Ecommerce />,
      },
      {
        code: 'QT',
        name: 'menu.quotation',
        key: 'quotation',
        route: '/quotation',
        component: <Quotation />,
      },
      {
        code: 'QTB',
        name: 'menu.quotation_branch',
        key: 'quotation_branch',
        route: '/quotation_branch',
        component: <QuotationBranch />,
      },
      {
        code: 'IV',
        name: 'menu.invoice',
        key: 'invoice',
        route: '/invoice',
        component: <Invoice />,
      },
      {
        code: 'RC',
        name: 'menu.receipt',
        key: 'receipt',
        route: '/receipt',
        component: <Receipt />,
      },
      {
        name: 'menu.saleman',
        key: 'saleman',
        route: '/saleman',
        component: <Saleman />,
      },
      {
        name: 'menu.task',
        key: 'task',
        route: '/task',
        component: <Task />,
      },
      {
        name: 'menu.meeting',
        key: 'meeting',
        route: '/meeting',
        component: <Meeting />,
      },
      {
        name: 'menu.promotion',
        key: 'promotion',
        route: '/promotion',
        component: <Promotion />,
      },
    ],
  },
  {
    type: 'collapse',
    name: 'menu.pos',
    key: 'pos_menu',
    icon: <Icon fontSize='medium'>point_of_sale</Icon>,
    collapse: [
      {
        name: 'menu.sale_order',
        key: 'sale_order',
        route: '/sale_order',
        component: <SaleOrder />,
      },
      {
        name: 'menu.pos',
        key: 'pos',
        route: '/pos',
        component: <PointOfSale />,
      },
      {
        name: 'menu.close_shift',
        key: 'close_shift',
        route: '/close_shift',
        component: <CloseShift />,
      },
      {
        name: 'menu.cashier_shift',
        key: 'cashier_shift',
        route: '/cashier_shift',
        component: <CashierShift />,
      },
      {
        name: 'menu.drop_money',
        key: 'drop_money',
        route: '/drop_money',
        component: <DropMoney />,
      },
      {
        name: 'menu.return_product',
        key: 'return_product',
        route: '/return_product',
        component: <ReturnProduct />,
      },
      {
        name: 'menu.cancel_bill',
        key: 'cancel_bill',
        route: '/cancel_bill',
        component: <CancelBill />,
      },
      {
        name: 'menu.cart',
        key: 'cart',
        route: '/cart',
        component: <Cart />,
      },
      {
        name: 'menu.cashier',
        key: 'cashier',
        route: '/cashier',
        component: <Cashier />,
      },
      {
        name: 'menu.announcement_setting',
        key: 'announcement_setting',
        route: '/announcement_setting',
        component: <AnnouncementSetting />,
      },
      {
        name: 'menu.qr_bottom_bill',
        key: 'qr_bottom_bill',
        route: '/qr_bottom_bill',
        component: <QrBottomBill />,
      },
      {
        name: 'menu.qrcode',
        key: 'qrcode',
        route: '/qrcode',
        component: <QrCode />,
      },
      {
        code: 'SC',
        name: 'menu.send_change',
        key: 'send_change',
        route: '/send_change',
        component: <SendChange />,
      },
      {
        name: 'menu.advertise_image',
        key: 'advertise_image',
        route: '/advertise_image',
        component: <AdvertiseImage />,
      },
      {
        name: 'menu.slideshow',
        key: 'slideshow',
        route: '/slideshow',
        component: <SlideShow />,
      },
      {
        name: 'menu.advertise_vdo',
        key: 'advertise_vdo',
        route: '/advertise_vdo',
        component: <AdvertiseVDO />,
      },
      {
        name: 'menu.pos_customer_screen',
        key: 'pos_customer_screen',
        route: '/pos_customer_screen',
        component: <PosCustomerScreen />,
      },
      {
        name: 'menu.pos_qrcode',
        key: 'pos_qrcode',
        route: '/pos_qrcode',
        component: <PosQrCode />,
      },
      {
        name: 'menu.coupon',
        key: 'coupon',
        route: '/coupon',
        component: <Coupon />,
      },
      {
        name: 'menu.country',
        key: 'country',
        route: '/country',
        component: <Country />,
      },
      {
        name: 'menu.import_sale',
        key: 'import_sale',
        route: '/import_sale',
        component: <ImportSale />,
      },
    ],
  },
  {
    type: 'collapse',
    name: 'menu.purchase',
    key: 'purchase_menu',
    icon: <Icon fontSize='medium'>shopping_basket</Icon>,
    collapse: [
      {
        code: 'PR',
        name: 'menu.purchase_request',
        key: 'purchase_request',
        route: '/purchase_request',
        component: <PurchaseRequest />,
      },
      {
        code: 'PO',
        name: 'menu.purchase_order',
        key: 'purchase_order',
        route: '/purchase_order',
        component: <PurchaseOrder />,
      },
      {
        name: 'menu.receive',
        key: 'receive',
        route: '/receive',
        component: <Receive />,
      },
      {
        name: 'menu.supplier',
        key: 'supplier',
        route: '/supplier',
        component: <Supplier />,
      },
      {
        name: 'menu.purchase_type',
        key: 'purchase_type',
        route: '/purchase_type',
        component: <PurchaseType />,
      },
      {
        name: 'menu.supplier_type',
        key: 'supplier_type',
        route: '/supplier_type',
        component: <SupplierType />,
      },
      {
        code: '',
        name: 'menu.purchase_invoice',
        key: 'purchase_invoice',
        route: '/purchase_invoice',
        component: <PurchaseInvoice />,
      },
    ],
  },
  {
    type: 'collapse',
    name: 'menu.warehouse',
    key: 'warehouse_menu',
    icon: <Icon fontSize='medium'>warehouse</Icon>,
    collapse: [
      {
        name: 'menu.export_invite',
        key: 'export_invite',
        route: '/export_invite',
        component: <ExportInvite />,
      },
      {
        name: 'menu.export_request',
        key: 'export_request',
        route: '/export_request',
        component: <ExportRequest />,
      },
      {
        name: 'menu.export_store',
        key: 'export_store',
        route: '/export_store',
        component: <ExportStore />,
      },
      {
        name: 'menu.import_store',
        key: 'import_store',
        route: '/import_store',
        component: <ImportStore />,
      },
      {
        name: 'menu.export_move',
        key: 'export_move',
        route: '/export_move',
        component: <ExportMove />,
      },
      {
        name: 'menu.location',
        key: 'location',
        route: '/location',
        component: <Location />,
      },
      {
        name: 'menu.warehouse',
        key: 'warehouse',
        route: '/warehouse',
        component: <Warehouse />,
      },
    ],
  },
  {
    type: 'collapse',
    name: 'menu.inventory',
    key: 'inventory_menu',
    icon: <Icon fontSize='medium'>store</Icon>,
    collapse: [
      {
        name: 'menu.return_store',
        key: 'return_store',
        route: '/return_store',
        component: <ReturnStore />,
      },
      {
        name: 'menu.credit_sales',
        key: 'credit_sales',
        route: '/credit_sales',
        component: <CreditSale />,
      },
      {
        name: 'menu.return_supplier',
        key: 'return_supplier',
        route: '/return_supplier',
        component: <ReturnSupplier />,
      },
      {
        name: 'menu.receive_store',
        key: 'receive_store',
        route: '/receive_store',
        component: <ReceiveStore />,
      },
      {
        name: 'menu.pickup_store',
        key: 'pickup_store',
        route: '/pickup_store',
        component: <PickupStore />,
      },
      {
        name: 'menu.counts_round',
        key: 'counts_round',
        route: '/counts_round',
        component: <Counts />,
      },
      {
        route: '/counts_round/:id',
        key: 'stock_take_id',
        component: <Counts />,
      },
      {
        route: '/counting_session/:id',
        key: 'counting_session_id',
        component: <CountingSession />,
      },
      {
        name: 'menu.counting_request',
        key: 'counting_request',
        route: '/counting_request',
        component: <CountingRequest />,
      },
      {
        name: 'menu.counting',
        key: 'counting',
        route: '/counting',
        component: <Counting />,
      },
      {
        route: '/counting/:id',
        key: 'counting_id',
        component: <Counting />,
      },
      {
        name: 'menu.receive_type',
        key: 'receive_type',
        route: '/receive_type',
        component: <ReceiveType />,
      },
      {
        name: 'menu.pickup_type',
        key: 'pickup_type',
        route: '/pickup_type',
        component: <PickupType />,
      },
      {
        name: 'menu.return_store_type',
        key: 'return_store_type',
        route: '/return_store_type',
        component: <ReturnStoreType />,
      },
      {
        name: 'menu.adjust_stock',
        key: 'adjust_stock',
        route: '/adjust_stock',
        component: <AdjustStock />,
      },
      {
        name: 'menu.bring_forward',
        key: 'bring_forward',
        route: '/bring_forward',
        component: <BringForward />,
      },
      {
        name: 'menu.export_sheet',
        key: 'export_sheet',
        route: '/export_sheet',
        component: <ExportSheet />,
      },
      {
        name: 'menu.pickup_rawmat',
        key: 'pickup_rawmat',
        route: '/pickup_rawmat',
        component: <PickupRawmat />,
      },
      {
        name: 'menu.export_request_tag',
        key: 'export_request_tag',
        route: '/export_request_tag',
        component: <ExportRequestTag />,
      },
      {
        name: 'menu.import_stock',
        key: 'import_stock',
        route: '/import_stock',
        component: <ImportStock />,
      },
      {
        name: 'menu.config_store',
        key: 'config_store',
        route: '/config_store',
        component: <ConfigStore />,
      },
    ],
  },
  {
    type: 'collapse',
    name: 'menu.production',
    key: 'production_menu',
    icon: <Icon fontSize='medium'>foundation</Icon>,
    collapse: [
      {
        name: 'menu.production_receive',
        key: 'production_receive',
        route: '/production_receive',
        component: <ProductionReceive />,
      },
      {
        name: 'menu.bom',
        key: 'bom',
        route: '/bom',
        component: <BillOfMaterial />,
      },
      {
        name: 'menu.production_init',
        key: 'production',
        route: '/production',
        component: <Production />,
      },
      // {
      //   name: "menu.joborder",
      //   key: "joborder",
      //   route: "/joborder",
      //   component: <JobOrder />,
      // },
      {
        name: 'menu.production_finish',
        key: 'production_finish',
        route: '/production_finish',
        component: <ProductionFinish />,
      },
      {
        name: 'menu.request_rawmat',
        key: 'request_rawmat',
        route: '/request_rawmat',
        component: <RequestRawmat />,
      },
      {
        name: 'menu.production_plan',
        key: 'production_plan',
        route: '/production_plan',
        component: <ProductionPlan />,
      },
    ],
  },
  {
    type: 'collapse',
    name: 'menu.shipping',
    key: 'shipping_menu',
    icon: <Icon fontSize='medium'>local_shipping</Icon>,
    collapse: [
      {
        name: 'menu.shipping_branch',
        key: 'shipping_branch',
        route: '/shipping_branch',
        component: <ShippingBranch />,
      },
      {
        name: 'menu.shipping',
        key: 'shipping',
        route: '/shipping',
        component: <Shipping />,
      },
      {
        name: 'menu.car',
        key: 'car',
        route: '/car',
        component: <Car />,
      },
    ],
  },
  {
    type: 'collapse',
    name: 'menu.report',
    key: 'report_menu',
    icon: <Icon fontSize='medium'>content_paste</Icon>,
    collapse: [
      {
        name: 'menu.report_product',
        key: 'report_product',
        route: '/report_product',
        component: <ReportProduct />,
      },
      {
        name: 'menu.report_sale',
        key: 'report_sale',
        route: '/report_sale',
        component: <ReportSale />,
      },
      {
        name: 'menu.report_pos',
        key: 'report_pos',
        route: '/report_pos',
        component: <ReportPOS />,
      },
      {
        name: 'menu.report_purchase',
        key: 'report_purchase',
        route: '/report_purchase',
        component: <ReportPurchase />,
      },
      {
        name: 'menu.report_stock',
        key: 'report_warehouse',
        route: '/report_warehouse',
        component: <ReportWarehouse />,
      },
      {
        name: 'menu.report_inventory',
        key: 'report_inventory',
        route: '/report_inventory',
        component: <ReportInventory />,
      },
      {
        name: 'menu.report_production',
        key: 'report_production',
        route: '/report_production',
        component: <ReportProduction />,
      },
      {
        name: 'menu.report_account',
        key: 'report_account',
        route: '/report_account',
        component: <ReportAccount />,
      },
      {
        name: 'menu.report_power_bi',
        key: 'report_power_bi',
        route: '/report_power_bi',
        component: <ReportPowerBi />,
      },
      {
        name: 'menu.report_manage_branch',
        key: 'report_manage_branch',
        route: '/report_manage_branch',
        component: <ReportManageBranch />,
      },
    ],
  },
  {
    type: 'collapse',
    name: 'menu.user',
    key: 'user_menu',
    icon: <Icon fontSize='medium'>people</Icon>,
    collapse: [
      {
        name: 'menu.user',
        key: 'user',
        route: '/user',
        component: <User />,
      },
      {
        name: 'menu.role',
        key: 'role',
        route: '/role',
        component: <Role />,
      },
      {
        name: 'menu.role_user',
        key: 'role_user',
        route: '/role_user',
        component: <RoleUser />,
      },
      {
        name: 'menu.prefix',
        key: 'prefix',
        route: '/prefix',
        component: <Prefix />,
      },
      {
        name: 'menu.department',
        key: 'department',
        route: '/department',
        component: <Department />,
      },
      {
        name: 'menu.position',
        key: 'position',
        route: '/position',
        component: <Position />,
      },
    ],
  },
  {
    type: 'collapse',
    name: 'menu.setting',
    key: 'setting_menu',
    icon: <Icon fontSize='medium'>settings</Icon>,
    collapse: [
      {
        name: 'menu.master_data',
        key: 'master_data',
        route: '/master_data',
        component: <MasterData />,
      },
      {
        name: 'menu.note',
        key: 'note',
        route: '/note',
        component: <Note />,
      },
      {
        name: 'menu.currency',
        key: 'currency',
        route: '/currency',
        component: <Currency />,
      },
      {
        name: 'menu.company',
        key: 'company',
        route: '/company',
        component: <Company />,
      },
      // {
      //   name: "menu.document",
      //   key: "document",
      //   route: "/document",
      //   component: <Document />,
      // },
      {
        name: 'menu.branch',
        key: 'branch',
        route: '/branch',
        component: <Branch />,
      },
      {
        name: 'menu.bank_account',
        key: 'bank_account',
        route: '/bank_account',
        component: <BankAccount />,
      },
      {
        name: 'menu.credit_card',
        key: 'credit_card',
        route: '/credit_card',
        component: <CreditCard />,
      },
      {
        name: 'menu.credit_card_fee',
        key: 'credit_card_fee',
        route: '/credit_card_fee',
        component: <CreditCardFee />,
      },
      {
        name: 'menu.qrcode_gen',
        key: 'qrcode_gen',
        route: '/qrcode_gen',
        component: <QrCodeGen />,
      },
      {
        name: 'menu.province',
        key: 'province',
        route: '/province',
        component: <Province />,
      },
      {
        name: 'menu.district',
        key: 'district',
        route: '/district',
        component: <District />,
      },
      {
        name: 'menu.subdistrict',
        key: 'subdistrict',
        route: '/subdistrict',
        component: <SubDistrict />,
      },
      {
        name: 'menu.posminiexample',
        key: 'posminiexample',
        route: '/posminiexample',
        component: <PosMiniExample />,
      },
      {
        name: 'menu.cash',
        key: 'cash',
        route: '/cash',
        component: <Cash />,
      },
      {
        name: 'menu.config',
        key: 'config',
        route: '/config',
        component: <Config />,
      },
      {
        name: 'menu.picture',
        key: 'picture',
        route: '/picture',
        component: <Picture />,
      },
      {
        name: 'menu.qr',
        key: 'qr',
        route: '/qr',
        component: <QR />,
      },
      {
        name: 'menu.log',
        key: 'log',
        route: '/log',
        component: <Log />,
      },
      {
        name: 'menu.criteria',
        key: 'criteria',
        route: '/criteria',
        component: <Criteria />,
      },
      {
        name: 'menu.backup',
        key: 'backup',
        route: '/backup',
        component: <Backup />,
      },
      {
        name: 'menu.developer_stock',
        key: 'developer_stock',
        route: '/developer_stock',
        component: <DeveloperStock />,
      },
    ],
  },
  {
    name: 'menu.coupon_list',
    key: 'coupon_gen',
    route: '/coupon_list',
    component: <CouponDetail />,
  },
];

export default routes;
